import { Component, OnInit, AfterViewInit } from '@angular/core';

import Parallax from 'parallax-js';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {

  scene: any;
  

  constructor() {
    if (window.screen.width < 768) {
      this.scene = document.getElementById('scene2');
    }else {
      this.scene = document.getElementById('scene');
    }
   }

  ngOnInit() {


  }

  ngAfterViewInit() {
    let alto = document.getElementById('home-section').offsetHeight;
    let elementos: any = document.getElementsByClassName('parallax-div');
    Array.from(elementos).forEach((elemento: HTMLElement) => {
      elemento.style.height = alto + 'px';
    });
    let scene = document.getElementById('scene');
    var parallaxInstance = new Parallax(scene);
  }

  getParallaxMovil() {
    if (window.screen.width < 768) {
      return true;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/home/home.component.ts